import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const bookOpenVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type BookOpenProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof bookOpenVariants> &
  IconProps;

export const BookOpen = React.forwardRef<SVGSVGElement, BookOpenProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          bookOpenVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M10 16.137C9.74327 16.4098 9.43336 16.6272 9.08937 16.7756C8.74539 16.9241 8.37464 17.0004 8 17H3.75C3.28587 17 2.84075 16.8156 2.51256 16.4874C2.18437 16.1592 2 15.7141 2 15.25V4.75C2 3.784 2.784 3 3.75 3H8C8.788 3 9.499 3.331 10 3.863C10.2567 3.59015 10.5666 3.37281 10.9106 3.22438C11.2546 3.07595 11.6254 2.99959 12 3H16.25C17.216 3 18 3.784 18 4.75V15.25C18 15.7141 17.8156 16.1592 17.4874 16.4874C17.1592 16.8156 16.7141 17 16.25 17H12C11.6254 17.0004 11.2546 16.9241 10.9106 16.7756C10.5666 16.6272 10.2567 16.4098 10 16.137ZM3.5 4.75V15.25C3.5 15.388 3.612 15.5 3.75 15.5H8C8.69 15.5 9.25 14.94 9.25 14.25V5.75C9.25 5.06 8.69 4.5 8 4.5H3.75C3.6837 4.5 3.62011 4.52634 3.57322 4.57322C3.52634 4.62011 3.5 4.6837 3.5 4.75ZM10.75 14.25C10.75 14.94 11.31 15.5 12 15.5H16.25C16.3163 15.5 16.3799 15.4737 16.4268 15.4268C16.4737 15.3799 16.5 15.3163 16.5 15.25V4.75C16.5 4.6837 16.4737 4.62011 16.4268 4.57322C16.3799 4.52634 16.3163 4.5 16.25 4.5H12C11.31 4.5 10.75 5.06 10.75 5.75V14.25Z" />
      </svg>
    );
  },
);

BookOpen.displayName = 'BookOpen';
